/*
 * Shared class constants for composed shadcn feature components.
 *
 * These originated in account/styles.ts, where they were pinned to the Figma
 * spec for the Account page. They are house style rather than account-specific,
 * so they live here and account/styles.ts re-exports them — any new surface
 * should import from this module so cards, titles and buttons stay one species
 * across the app instead of each page re-deriving them.
 */

// Figma "Variant=Outline/Destructive/Default, Size=sm": 28px tall, 10px radius, 10px x-padding.
export const SM_BUTTON = "tw:h-7 tw:rounded-md tw:px-2.5 tw:gap-1 tw:shadow-none"

// Dialog footer buttons (Cancel / Save changes): 32px tall.
export const MD_BUTTON = "tw:h-8 tw:rounded-md tw:px-2.5 tw:gap-1.5 tw:shadow-none"

export const CARD =
  "tw:gap-0 tw:py-0 tw:ring-0 tw:border tw:border-border tw:shadow-xs tw:rounded-xl tw:bg-card tw:overflow-hidden"
export const CARD_HEADER = "tw:p-4 tw:gap-1"
export const CARD_TITLE =
  "tw:text-base tw:font-medium tw:leading-6 tw:text-card-foreground"
export const CARD_DESCRIPTION =
  "tw:text-sm tw:font-normal tw:leading-5 tw:text-muted-foreground"
